import * as React from "react";
import { LobQueryRouterProps, ActiveLobSwitchProps } from "./typings";
import { QueryRoute } from "bernie-core";
import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import { inject } from "mobx-react";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { wizardLobQueryParamKey } from "../constants";

/**
 * The source of truth to determinate whether a lob form will be rendered or not
 * Is fully managed by the WizardState, this router is the interface bettewn
 * The query param in the url and the wizardState
 */

// Define all the possible routes base on the flex template
export const LobQueryRouter: React.FunctionComponent<LobQueryRouterProps> = inject("wizardState")(
  ({ lobs, wizardState }) => {
    const keyHelper = new ItemKeyHelper("lobQueryRouter");

    if (!wizardState) {
      return null;
    }

    if (lobs.length === 1) {
      // For single lob set it as an active instead of relying on the QueryRoute
      wizardState.setActiveLob(lobs[0].name);

      return null;
    }

    return (
      <React.Fragment>
        {lobs.map((flexComponent: FlexComponent) => (
          <QueryRoute key={keyHelper.next()} query={{ [wizardLobQueryParamKey]: flexComponent.model.name }}>
            <ActiveLobSwitch lobName={flexComponent.model.name} />
          </QueryRoute>
        ))}
      </React.Fragment>
    );
  }
);

// Component called by QueryRoute which its only purpose is to set the active lob
const ActiveLobSwitch: React.FunctionComponent<ActiveLobSwitchProps> = inject("wizardState")(
  ({ wizardState, lobName }) => {
    if (wizardState) {
      wizardState.setActiveLob(lobName);
    }

    return null;
  }
);
